// Accounts created from a WhatsApp number (signup with Que) hold this placeholder email until they verify a real one.
// It is never a mailbox: nothing is sent to it, and the one-workspace and repeat-trial rules key on it per phone.
const PHONE_ACCOUNT_EMAIL_DOMAIN = "phone.querygen.ai";

export function phoneAccountEmail(phone: string): string {
  return `${phone.replace(/\D/g, "")}@${PHONE_ACCOUNT_EMAIL_DOMAIN}`;
}

export function isPhoneAccountEmail(email: string | null | undefined): boolean {
  return Boolean(email && email.trim().toLowerCase().endsWith(`@${PHONE_ACCOUNT_EMAIL_DOMAIN}`));
}

/** What to show where an account's email would go: a placeholder isn't an address anyone would recognise */
export function accountEmailLabel(email: string): string {
  return isPhoneAccountEmail(email) ? "Signed up on WhatsApp" : email;
}
